export default __webpack_public_path__ + "static/media/name.f734b6ed.PNG";